import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { produce } from 'passiv-libs'
import { LPA } from 'passiv-api'

import EmailUpdate from './email-update'

const EmailUpdateContainer = () => {
  const history = useHistory()
  const location = useLocation()
  const [state, setState] = useState({
    loading: true,
    title: '',
    text: ''
  })

  useEffect(() => {
    const { username, verificationCode } = Object.fromEntries(new URLSearchParams(location.search))
    confirmUpdateEmailVerificationCode({ username, verificationCode })
  }, [])

  const confirmUpdateEmailVerificationCode = async ({ username, verificationCode }) => {
    try {
      await LPA.PUT.confirmUpdateEmailVerificationCode({ username, verificationCode })
      setState(
        produce(draft => {
          draft.title = 'Your PassivLiving email address has been successfully changed.'
          draft.text =
            'Visit the PassivLiving portal using the link below or launch the PassivLiving App.'
        })
      )
    } catch (err) {
      if (err === 400) {
        setState(
          produce(draft => {
            draft.title = 'Your confirmation link is incorrect.'
            draft.text =
              'Visit the PassivLiving portal using the link below or launch the PassivLiving App.'
          })
        )
      } else {
        setState(
          produce(draft => {
            draft.title = 'Your confirmation link has expired.'
            draft.text =
              'Visit the accounts page to change your email address once more if needed. '
          })
        )
      }
    }
    setState(
      produce(draft => {
        draft.loading = false
      })
    )
  }

  return <EmailUpdate {...state} onClickButton={() => history.push('/login')} />
}

export default EmailUpdateContainer
